<template>
    <div v-if="amountOfCharts > 0" class="charts">
        <div class="section-header" v-if="!showingSmallCharts" :id="chartsTagId + 'header'"><h2>Kuvaajat</h2></div>
        <div :id="chartsTagId">
            <div class="section-header" v-if="showingSmallCharts"><h2>Kuvaajat</h2></div>
            <div class="row">
                <div
                    v-if="!showingSmallCharts"
                    style="min-height: 420px"
                    class="col-lg-12 graph charts-stuff big-charts"
                    v-for="index in amountOfCharts">

                    <div>Kuvaajan tyyppi: </div>
                    <select v-on:change="recreateChart(index, $event.target.value)" style="width: 10%">
                        <option v-for="type in chartTypes"
                                :id="type"
                                :name="type"
                                :selected="getSelectedType(type, index)">
                            {{ type }}
                        </option>
                    </select>

                    <div style="height: 370px;">
                        <canvas :id="getUniqueIdForChart(index)"></canvas>
                    </div>
                    <div class="chart-summaries">
                        <div>Keskiarvo: <span :id="getUniqueIdForChart(index) + 'average'"></span></div>
                        <div>Mediaani: <span :id="getUniqueIdForChart(index) + 'median'"></span></div>
                        <div>Min: <span :id="getUniqueIdForChart(index) + 'min'"></span></div>
                        <div>Max: <span :id="getUniqueIdForChart(index) + 'max'"></span></div>
                    </div>

                    <span v-if="getChartUnit(index)" v-on:click="showBillingForm(getUniqueIdForBillingForm(index))" style="float:right; cursor:pointer;"><md-icon>assignment</md-icon></span>
                    <div class="billingInformation" :id="getUniqueIdForBillingForm(index)" style="display:none">
                        <div class="billingContent"><h1 style="font-size: 30px;">{{ deviceName }}</h1></div>
                        <div class="billingForm">
                            <label>Otsikko <input class="billing-title" type="text" value="" placeholder="Otsikko (esim. Sähkön kulutus)"></label>
                            <label>Paikka <input class="billing-location" type="text" value="" placeholder="Paikka (esim. Verkkosaaren tukikohta)"></label>
                            <label>Alkuarvo <input class="billing-start-value" :id="getUniqueIdForChart(index) + 'first'" type="text" value=""></label>
                            <label>Loppuarvo <input class="billing-end-value" :id="getUniqueIdForChart(index) + 'last'" type="text" value=""></label>
                            <label>Yksikkö <input class="billing-unit" type="text" value="" placeholder="(Esim. Kwh)"></label>
                            <label>Hinta per yksikkö<input class="billing-price-per-unit" type="number" value=""></label>
                            <label>Veron nimi<input class="billing-tax-name" type="text" value=""></label>
                            <label>Veroprosentti (1%-100%)<input class="billing-tax" type="number" min="0" max="100" value=""></label>
                        </div>
                        <button class="btn btn-success" v-on:click="generateBillingPdf(getUniqueIdForBillingForm(index), getUniqueIdForChart(index))">Luo PDF-lasku</button>
                    </div>


                </div>

                <div v-if="showingSmallCharts" class="col-lg-6 charts-stuff small-charts" v-for="index in amountOfCharts">
                    <canvas :id="getUniqueIdForChart(index)"></canvas>
                    <div class="chart-summaries">
                        <div>Keskiarvo: <span :id="getUniqueIdForChart(index) + 'average'"></span></div>
                        <div>Mediaani: <span :id="getUniqueIdForChart(index) + 'median'"></span></div>
                        <div>Min: <span :id="getUniqueIdForChart(index) + 'min'"></span></div>
                        <div>Max: <span :id="getUniqueIdForChart(index) + 'max'"></span></div>
                    </div>
                </div>

            </div>


        </div>
    </div>
</template>

<script>
    export default {
        name: 'charts-component',
        props: {
            amountOfCharts: Number,
            chartsTagId: String,
            deviceId: String,
            deviceName: String,
            chartUnits: Array,
            chartTypes: Array,
            observationTypes: Array,
            smallCharts: Boolean,
            parentParentSetContentToBeAddedToBillingPdf: Function,
            parentParentCreateInitialBillingPdf: Function
        },
        data() {
            return {
                showSmallCharts: false,
            }
        },
        computed: {
            showingSmallCharts() {
                return this.$store.getters.showSmallCharts
            },
        },
        methods: {
            getUniqueIdForChart(index) {
                return "deviceCanvas" + index + this.deviceId
            },
            getUniqueIdForBillingForm(index) {
                return "billing-" + index + this.deviceId
            },
            getChartUnit(index) {
                return (this.chartUnits[index-1] === 'kwh');
            },
            getSelectedType(type, index) {
                return (type === this.observationTypes[this.deviceId][index-1])
            },
            generateBillingPdf(chartUniqueId) {
                let pdf = this.parentParentCreateInitialBillingPdf()
                this.parentParentSetContentToBeAddedToBillingPdf(chartUniqueId, pdf, this.deviceName);
            },
            recreateChart(index, value) {
                this.$parent.recreateChart(index, value);
            },
            showBillingForm(id){
                let element = document.getElementById(id)
                if(element.style.display == "block"){
                    element.style.display = "none";
                } else{
                    element.style.display = "block";
                }
            }
        },
    }
</script>

<style>
    .charts-stuff {
        color: black;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        /*border: solid 2px gray;*/
    }
    .big-charts {
        margin-bottom: 35px;
    }
    .small-charts {
       padding: 26px;
    }
    .chart-summaries {
        padding: 5px;
        display: flex;
        justify-content: space-around;
        border: solid 1px lightgray;
        border-radius: 6px;
    }
    .charts {
        width: 100%;
        margin: auto;
        margin-right: 20px;
    }
    .section-header h2 {
        color: #000;
        font-size: 25px
    }

    .billingInformation{
        margin-top: 20px;
    }
    .billingInformation label{
        width: 100%;
    }
    .billingInformation input{
        width: 100%;
    }
    .billingForm label{
        width: 49%;
        float: left;
        margin-right: 1%;
    }
</style>



// WEBPACK FOOTER //
// src/app/Main/components/Charts.vue